<template>
  <div id="property-modal" class="modal"  v-show="modalShown">
    <div class="modal-main">
      <dd-room-modal
        ref="roomModalRef"
        @getRoomList="getRoomList"
      />
      <dd-business-modal
        ref="businessModalRef"
        @getBusinessList="getBusinessList"
      />
      <div class="title-area">
        <h2>ルーム/プラン情報設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <ul>
          <div class="button_li">
            <li>
              <span class="label">ルーム<span class="required">【必須】</span></span>
              <select v-model="propertyRoomId" @change="changeRoom" class="form_contents">
                <option v-for="(room, index) in roomList" :key=index :value="room.cpropertyRoomId">
                  {{ concateBuidingFloorRoomName(room) }}</option>
              </select>
              <div class="validate_error_messages">{{ validateErrorMessages.propertyRoomId }}</div>
            </li>
            <li>
              <button type="button" class="main_btn" @click="openNewRoomModal">新規ルーム登録</button>
              <button type="button" class="main_btn" @click="openEditRoomModal">ルーム情報編集</button>
            </li>
          </div>
          <li>
            <span class="label">場所名</span>
            <input type="text" v-if="editPlanData" v-model="editPlanData.cpropertyRoomPlaceName" class="form_contents">
            <input type="text" v-else v-model="propertyRoomPlaceName" placeholder="場所名" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyRoomPlaceName }}</div>
          </li>
          <li>
            <input type="text" v-model="searchUmcode" class="form_contents">
            <button class="main_btn" @click="searchByUmcode">UMコード検索</button>
          </li>
          <li>
            <span class="label">UMコードおよびプラン名<span class="required">【必須】</span></span>
            <select class="select-input" v-model="propertyRoomFdId" ref="propertyRoomFdIdSelect">
              <option v-for="(file, index) in selectFileDataList" :key= index :value="file.cfdId" >
                {{ file.cfileName + ' ' + file.cfileCode }}</option>
            </select>
            <div class="validate_error_messages">{{ validateErrorMessages.propertyRoomFdId }}</div>
          </li>
          <li>
            <span class="label">数量<span class="required">【必須】</span></span>
            <input type="number" v-if="editPlanData" v-model="editPlanData.cpropertyRoomFdCount" class="form_contents">
            <input type="number" v-else v-model="propertyRoomFdCount" placeholder="数量" class="form_contents">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyRoomFdCount }}</div>
          </li>
          <div class="button_li">
            <li>
              <span class="label">納入先および担当者</span>
              <select v-model="propertyRoomTargetId" @change="changeBusiness" class="form_contents" ref="propertyRoomTargetSelect">
                <option value=""></option>
                <option v-for="(business, index) in businessList" :key= index :value="business.businessId" >
                  {{ businessNameAndParson(business) }}</option>
              </select>
            </li>
            <li>
              <button type="button" class="main_btn" @click="openNewBusinessModal">新規納入先登録</button>
              <button type="button" class="main_btn" @click="openEditBusinessModal">納入先情報編集</button>
            </li>
          </div>
          <li>
            <span class="label">着荷日</span>
            <input type="date" v-if="editPlanData" v-model="editPlanData.cpropertyArrivalDate" class="form_contents">
            <input type="date" v-else v-model="propertyArrivalDate" placeholder="着荷日" class="form_contents">
          </li>
          <li>
            <span class="label">納入時刻</span>
            <input type="time" v-if="editPlanData" v-model="editPlanData.cpropertyDeliveryTime" class="form_contents">
            <input type="time" v-else v-model="propertyDeliveryTime" placeholder="納入時刻" class="form_contents">
          </li>
        </ul>
      </div>
      <div class="error_message">{{ errorMessage.text }}</div>
      <div class="button-area">
        <button type="button" class="main_btn" v-if="editPlanData && !isCopy" @click="updatePlanData">設定</button>
        <button type="button" class="main_btn" v-else @click="updatePlanData">登録</button>
        <button type="button" class="main_btn" v-if="editPlanData && !isCopy" @click="confirmDelete">削除</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import {API_URL} from '../../../constants/App'
import RoomModal from '../modal/RoomModal'
import BusinessModal from '../../planning/modal//BusinessModal'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'PropertyPlanModal',
  components: {
    'dd-room-modal': RoomModal,
    'dd-business-modal': BusinessModal,
    'dd-loading-modal': LoadingModal
  },
  props: {
    businessList: Array,
    propertyData: Object,
    roomList: Array,
    fileDataList: Array
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** ルーム/プラン情報 */
      propertyRoomId: null,
      propertyRoomPlaceName: null,
      propertyRoomFdId: null,
      propertyRoomFdCount: null,
      propertyRoomTargetId: null,
      propertyArrivalDate: null,
      propertyDeliveryTime: null,
      /** 選択プラン一覧 */
      selectFileDataList: '',
      /** 検索用UMコード */
      searchUmcode: '',
      /** 編集中データ */
      editPlanData: null,
      /** 選択中のルーム */
      selectedRoom: null,
      /** 選択中の納入先 */
      selectedBusiness: null,
      /** 複製モードフラグ */
      isCopy: false,
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  methods: {
    /** 新規モーダル */
    showNewModal: function () {
      this.isCopy = false
      this.selectFileDataList = this.fileDataList
      this.clearData()
      this.modalShown = true
    },
    /** 編集モーダル */
    showEditModal: function (data) {
      this.isCopy = false
      this.selectFileDataList = this.fileDataList
      this.clearData()
      this.editPlanData = Object.assign({}, data)
      this.propertyRoomId = data.cpropertyRoomId
      this.propertyRoomFdId = data.cpropertyRoomFdId
      this.propertyRoomTargetId = data.cpropertyRoomTargetId
      this.editPlanData.cpropertyArrivalDate = this.getFormatDate(this.editPlanData.cpropertyArrivalDate)
      this.modalShown = true
    },
    /** 複製モーダル */
    showCopyModal: function (data) {
      this.isCopy = true
      this.clearData()
      this.editPlanData = Object.assign({}, data)
      this.propertyRoomId = data.cpropertyRoomId
      this.propertyRoomFdId = data.cpropertyRoomFdId
      this.propertyRoomTargetId = data.cpropertyRoomTargetId
      this.editPlanData.cpropertyArrivalDate = this.getFormatDate(this.editPlanData.cpropertyArrivalDate)
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.clearData()
      this.modalShown = false
      this.$emit('onSearch')
    },
    /** ルーム新規モーダルを開く */
    openNewRoomModal: function () {
      this.$refs.roomModalRef.showNewModal(this.propertyData.cpropertyId)
    },
    /** ルーム編集モーダルを開く */
    openEditRoomModal: function (data) {
      this.changeRoom()
      this.$refs.roomModalRef.showEditModal(this.selectedRoom)
    },
    /** 納入先新規モーダルを開く */
    openNewBusinessModal: function () {
      this.$refs.businessModalRef.showNewModal()
    },
    /** 納入先編集モーダルを開く */
    openEditBusinessModal: function (data) {
      this.changeBusiness()
      this.$refs.businessModalRef.showEditModal(this.selectedBusiness)
    },
    // ルームの変更
    changeRoom: function () {
      this.selectedRoom = this.roomList.find(room => room.cpropertyRoomId === this.propertyRoomId)
    },
    // 納入先の変更
    changeBusiness: function () {
      this.selectedBusiness = this.businessList.find(business => business.businessId === this.propertyRoomTargetId)
    },
    // UMコードでのプラン検索
    searchByUmcode: function () {
      if (!this.searchUmcode) {
        this.selectFileDataList = this.fileDataList
      } else {
        this.selectFileDataList = this.fileDataList.filter(file => file.cfileCode.indexOf(this.searchUmcode) > -1)
      }
    },
    /** ルームプラン情報更新 */
    updatePlanData: function () {
      this.validateErrorMessages = {}
      let isVarid = this.validCount(this.editPlanData ? this.editPlanData.cpropertyRoomFdCount : this.propertyRoomFdCount, 'propertyRoomFdCount', '数量')
      if (!isVarid) { return }
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        propertyRoomPlanId: (this.editPlanData && !this.isCopy) ? this.editPlanData.cpropertyRoomPlanId : null,
        propertyRoomId: this.propertyRoomId,
        propertyRoomPlaceName: this.editPlanData ? this.editPlanData.cpropertyRoomPlaceName : this.propertyRoomPlaceName,
        propertyRoomFdId: this.$refs.propertyRoomFdIdSelect.selectedIndex !== -1 ? this.propertyRoomFdId : null,
        propertyRoomFdCount: this.editPlanData ? this.editPlanData.cpropertyRoomFdCount : this.propertyRoomFdCount,
        propertyRoomTargetId: this.$refs.propertyRoomTargetSelect.selectedIndex !== -1 ? this.propertyRoomTargetId : null,
        propertyArrivalDate: this.editPlanData ? this.editPlanData.cpropertyArrivalDate : this.propertyArrivalDate,
        propertyDeliveryTime: this.editPlanData ? this.editPlanData.cpropertyDeliveryTime : this.propertyDeliveryTime
      }
      if (!this.editPlanData || this.isCopy) {
        axios.post(API_URL.PROPERTY + '/plan/add', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['登録しました'],
            onOk: () => {
              this.modalShown = false
              this.$emit('showDetailPage')
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      } else {
        axios.post(API_URL.PROPERTY + '/plan/update', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['変更しました'],
            onOk: () => {
              this.modalShown = false
              this.$emit('showDetailPage')
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      }
    },
    /** 削除確認 */
    confirmDelete: function () {
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'left',
        onOk: this.deleteSubmit
      }
      AppUtil.showModal(modalData)
    },
    /** ルームプラン情報更新 */
    deleteSubmit: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        targetId: this.editPlanData.cpropertyRoomPlanId
      }
      axios.post(API_URL.PROPERTY + '/plan/delete', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.showModal = false
          let modalData = {
            messages: ['削除しました。'],
            onOk: () => {
              this.modalShown = false
              this.$emit('showDetailPage')
            }
          }
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    /** 数量入力チェック */
    validCount: function (count, key, errorMessage) {
      var pattern = /^[0-9]{1,2}$/
      if (count && !pattern.test(count)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は99以下の整数で設定してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    clearData: function () {
      this.propertyRoomId = null
      this.propertyRoomPlaceName = null
      this.propertyRoomFdId = null
      this.propertyRoomFdCount = null
      this.propertyRoomTargetId = null
      this.propertyArrivalDate = null
      this.propertyDeliveryTime = null
      this.searchUmcode = ''
      this.editPlanData = null
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}
    },
    /** ルーム情報の更新 */
    getRoomList: function (propertyId) {
      this.$emit('getPropertyPlanData', propertyId)
    },
    /** 納入先の更新 */
    getBusinessList: function () {
      this.$emit('onSearch')
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    /** 納入先および担当者表示 */
    businessNameAndParson: function (business) {
      let businessName = business.businessName !== null ? business.businessName : ''
      let parsonLastName = business.businessPersonLastName1 !== null ? business.businessPersonLastName1 : ''
      let parsonFirstName = business.businessPersonFirstName1 !== null ? business.businessPersonFirstName1 : ''
      return businessName + ' ' + parsonLastName + ' ' + parsonFirstName
    },
    concateBuidingFloorRoomName: function (room) {
      let buildingName = room.cpropertyBuildingName !== null ? room.cpropertyBuildingName : ''
      let floorName = room.cpropertyFloorName !== null ? room.cpropertyFloorName : ''
      let roomName = room.cpropertyRoomName !== null ? room.cpropertyRoomName : ''
      return buildingName + ' ' + floorName + ' ' + roomName
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.data-area {
  padding: 20px;
  max-height: 700px;
  overflow: auto;
  min-width: 550px;
  .select-input {
    min-width: 360px;
  }
}
.modal-main{
  max-height: 100%;
  max-width: 580px;
}
.count_limit{
  font-size: 8px;
}
.form_contents{
  min-width: 220px;
}
.required{
  color: #ff0000;
}
.validate_error_messages {
  color: #dc3545;
  text-align: left;
  min-width: 400px;
}
.button_li{
    border-bottom:1px solid #ccc;
    border-top:1px solid #ccc;
    padding: 20px;
    margin: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/PropertyPlanModal.vue